<template>
  <div class="worksheetdetail-container">
    <div class="jc-page-header">
      <h1>
        <a href="javascript:void(0)"
           @click="goBack">
          <i class="el-icon-arrow-left"></i>
        </a>{{$t('ticket.workDetail')}}
      </h1>
      <div class="jc-box-action">
        <el-button @click="handleOption(ticketNo,'verify1')"
                   type="primary"
                   size="small"
                   v-if="userOperation.indexOf(3) > -1
                   && worksheetDetail.currentTaskNodeId === 'Plan_Verify'">
          {{$t('text.verify')}}</el-button>
        <el-button @click="handleOption(ticketNo,'verify2')"
                   type="primary"
                   size="small"
                   v-if="userOperation.indexOf(3) > -1
                   && worksheetDetail.currentTaskNodeId === 'Consign_Verify'">
          {{$t('text.verify')}}</el-button>
        <el-button @click="handleOption(ticketNo,'revoke')"
                   type="primary"
                   size="small"
                   v-if="userOperation.indexOf(2) > -1">
          {{$t('text.revokeVerb')}}</el-button>
        <el-button @click="handleOption(ticketNo,'close')"
                   type="primary"
                   size="small"
                   v-if="userOperation.indexOf(4) > -1">
          {{$t('text.closeTicket')}}</el-button>
        <el-button @click="handleOption(ticketNo,'verifyConfirm')"
                   type="primary"
                   size="small"
                   v-if="userOperation.indexOf(3) > -1 && worksheetDetail.currentTaskNodeId === 'Consumer_Confirm'">
          {{$t('text.verify')}}</el-button>
      </div>
    </div>
    <div class="jc-page-content">
      <!-- 步骤条 began-->
      <ticket-steps :stepsFlow="ticketSteps">
        <div class="reject-info"
             v-if="worksheetDetail.breakReasonType && !(serviceSupportCode.indexOf(this.ticketTemplateCode) > -1)">
          <el-alert v-if="worksheetDetail.breakReasonType == $t('ticket.cancelReason')"
                    :title="(worksheetDetail.breakReason
                    ? worksheetDetail.breakReason: '--')"
                    type="warning"
                    :closable="false"></el-alert>
          <el-alert v-if="worksheetDetail.breakReasonType != $t('ticket.cancelReason')"
                    :title="worksheetDetail.breakReasonType
                    + ':' + (worksheetDetail.breakReason
                    ? worksheetDetail.breakReason: '--')"
                    type="warning"
                    :closable="false"></el-alert>
        </div>
      </ticket-steps>
      <!-- 步骤条 end-->
      <div class="main-info">
        <!-- 基本信息 -->
        <ticket-info :ticketInfo="baseInfo"
                     :ticketTitle="$t('merge.basicInfo')"
                     v-if="serviceSupportCode.indexOf(ticketTemplateCode) > -1 "></ticket-info>
        <!-- TODO 用 ticket-info 重构-->
        <div class="el-section"
             v-else>
          <div class="el-section-header">
            <h3 class="el-section-title">{{$t('merge.basicInfo')}}</h3>
          </div>
          <div class="el-section-content">
            <el-form class="jc-datashow-list jc-datashow-list-inline">
              <el-form-item :label="$t('ticket.ticketNo') + '：'">
                <p>{{worksheetDetail.ticketNo !== ""? worksheetDetail.ticketNo : '--'}}</p>
              </el-form-item>
              <el-form-item :label="$t('ticket.workName') +'：'">
                <p>{{worksheetDetail.ticketName !== ""? worksheetDetail.ticketName : '--'}}</p>
              </el-form-item>
              <el-form-item :label="$t('ticket.workType')+ '：'">
                <p>{{worksheetDetail.ticketTypeName !== ""
                  ? worksheetDetail.ticketTypeName : '--'}}</p>
              </el-form-item>
              <el-form-item :label="$t('ticket.workStatus')+'：'">
                <p>{{worksheetDetail.ticketStatus !== ""
                  ? worksheetDetail.ticketStatus : '--'}}</p>
              </el-form-item>
              <el-form-item :label="$t('ticket.setUpTime')+ '：'">
                <p>{{worksheetDetail.createdTime !== ""
                  ? worksheetDetail.createdTime : '--'}}</p>
              </el-form-item>
              <el-form-item :label="$t('ticket.closeTime')+ '：'">
                <p>{{worksheetDetail.closedTime !== ""
                  ? worksheetDetail.closedTime: "--"}}</p>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 申请信息 -->
        <ticket-info :ticketInfo="applyInfo"
                     :ticketExtra="ticketExtra"
                     :ticketTitle="$t('ticket.applyInfo')"
                     :attachInfo="attachInfo"
                     v-if="serviceSupportCode.indexOf(ticketTemplateCode) > -1">
          <ticket-info-table :ticketInfoTable="deviceInfoList"
                             v-if="deviceInfoList.length > 0
                             && ticketTemplateCode !== 'CollectDelivery'
                             && ticketTemplateCode !== 'SendDelivery'
                             && ticketTemplateCode !== 'GeneralServices'
                             && ticketTemplateCode !== 'DeviceUnsubscribe'
                             && ticketTemplateCode !== 'DeviceOpen'"
                             :ticketTableTitle="$t('equipment.equipmentList')">
          </ticket-info-table>
          <package-info :ticketInfoTable="packageInfo"
                        :ticketTemplateCode="ticketTemplateCode"
                        v-if="packageInfo.length > 0
                             && (ticketTemplateCode === 'CollectDelivery'
                             || ticketTemplateCode === 'SendDelivery')"
                        :ticketTableTitle="ticketTemplateCode === 'CollectDelivery' ? $t('expressDelivery.packageListInfo'): $t('expressDelivery.sendListInfo')">
          </package-info>
          <!-- 通用服务 -->
          <GeneralServices-table :ticketInfoTable="worksheetDetail.deviceInfo"
                                 :ticketTemplateCode="ticketTemplateCode"
                                 v-if="ticketTemplateCode === 'GeneralServices' && worksheetDetail.deviceInfo.length > 0">
          </GeneralServices-table>
          <!-- 设备开通 -->
          <resource-table :ticketInfoTable="worksheetDetail.deviceInfo"
                                 :ticketTemplateCode="ticketTemplateCode"
                                 v-if="ticketTemplateCode === 'DeviceOpen' && worksheetDetail.deviceInfo.length > 0">
          </resource-table>
          <!-- 外件配置 -->
          <accessory-table :tableData="accessoryInfoList"
                           v-if="accessoryInfoList.length > 0
                           && ticketTemplateCode !== 'CollectDelivery'
                           && ticketTemplateCode !== 'SendDelivery'"
                           :ticketTableTitle="$t('serviceSupport.accessoryInfoTable')">
          </accessory-table>
          <!-- 机柜列表 -->
          <cabinet-table :tableData="cabinetInfoList"
                         v-if="cabinetInfoList.length > 0
                         && ticketTemplateCode === 'CabinetView'"
                         :ticketTableTitle="$t('serviceSupport.cabinetList')"></cabinet-table>
          <!-- 核实布线距离 -->
          <cabinet-a-b :tableData="cabinetInfoList"
                       v-if="cabinetInfoList.length > 0
                       && ticketTemplateCode === 'VerifyWiringDistance'"
                       :ticketTableTitle="$t('serviceSupport.cabinetList')"></cabinet-a-b>
          <!-- 机柜加电 -->
          <cabinet-power :tableData="cabinetInfoList"
                         v-if="cabinetInfoList.length > 0
                         && (ticketTemplateCode === 'CabinetElectrified' || ticketTemplateCode === 'CabinetPowerOff')"
                         :ticketTableTitle="$t('serviceSupport.cabinetList')"></cabinet-power>
          <!-- 机柜预留 -->
          <cabinet-reserve :tableData="cabinetInfoList"
                           v-if="cabinetInfoList.length > 0
                     && ticketTemplateCode === 'CabinetReservation'"
                           :ticketTableTitle="$t('cabinetReservation.applyList')"></cabinet-reserve>
          <!-- 设备退订 -->
          <device-undescrib :tableData="deviceInfoList"
                            v-if="deviceInfoList.length > 0
                     && ticketTemplateCode === 'DeviceUnsubscribe'"
                            :ticketTableTitle="$t('cabinetPowerOff.unsubscribe')"></device-undescrib>
        </ticket-info>
        <div class="el-section"
             v-else>
          <div class="el-section-header">
            <h3 class="el-section-title">{{$t('ticket.applyInfo')}}</h3>
          </div>
          <div class="el-section-content">
            <el-form class="jc-datashow-list jc-datashow-list-inline">
              <el-form-item :label="$t('merge.roomName')+ '：'"
                            v-if="worksheetDetail.ticketTemplateCode !== 'DeviceMoveOut' || worksheetDetail.ticketTemplateCode !== 'DeviceMoveOutV2'">
                <p>{{worksheetDetail.region !== ""? worksheetDetail.region: "--"}}</p>
              </el-form-item>
              <!-- 此处是入室目的 -->
              <el-form-item :label="$t('text.entrancePurpose')  | withColon"
                            v-if="worksheetDetail.ticketTemplateCode == 'VisitApplication'">
                <p>{{worksheetDetail.purposeName | maybeEmpty}}</p>
              </el-form-item>
              <!-- 此处入室原因 -->
              <el-form-item :label="$t('text.reasonInfo')  | withColon"
              v-if="worksheetDetail.ticketTemplateCode == 'VisitApplicationV2'">
                <div>
                
                    <el-tooltip
                      placement="bottom"
                      v-model="worksheetDetail.showTooltip"
                      :disabled="!worksheetDetail.showTooltip"
                  >
                      <div slot="content" class="custom-tooltip-text">{{worksheetDetail.reason}}</div>
                      <div
                          class="more-text-ellipsis"
                          @mouseenter="hasShowTooltip($event, worksheetDetail, worksheetDetail.reason)"
                      >
                          <span>
                              {{worksheetDetail.reason | maybeEmpty}}
                          </span>    
                      </div>
                  </el-tooltip>
                </div>
              </el-form-item>
              <!-- <el-form-item :label="$t('ticket.userPin')+ '：'">
                <p>{{worksheetDetail.pin !== ""? worksheetDetail.pin: "--"}}</p>
              </el-form-item> -->
              <!-- <el-form-item :label="$t('text.fullName')+ '：'">
                <p>{{worksheetDetail.userName !== ""? worksheetDetail.userName: "--"}}</p>
              </el-form-item> -->
              <el-form-item :label="$t('text.applyId')+ '：'">
                <p>{{worksheetDetail.applyId !== ""? worksheetDetail.applyId: "--"}}</p>
              </el-form-item>
              <el-form-item :label="$t('text.tel')+ '：'">
                <p>{{worksheetDetail.userTel !== ""? worksheetDetail.userTel: "--"}}</p>
              </el-form-item>
              <el-form-item :label="$t('text.email')+ '：'">
                <p>{{worksheetDetail.userEmail !== ""? worksheetDetail.userEmail: "--"}}</p>
              </el-form-item>
              <!--设备迁出机房名称展示位置-->
              <el-form-item :label="$t('merge.roomName')+ '：'"
                            v-if="worksheetDetail.ticketTemplateCode === 'DeviceMoveOut' || worksheetDetail.ticketTemplateCode === 'DeviceMoveOutV2'">
                <p>{{worksheetDetail.region !== ""? worksheetDetail.region: "--"}}</p>
              </el-form-item>
              <!-- 合同编号 -->
              <el-form-item :label="$t('ticket.contractEditNum')+ '：'"
                            v-if="worksheetDetail.ticketTemplateCode != 'DeviceMoveIn'
                            && worksheetDetail.ticketTemplateCode != 'DeviceMoveInV2'
                            && worksheetDetail.ticketTemplateCode !== 'VisitApplication'
                            && worksheetDetail.ticketTemplateCode !== 'VisitApplicationV2'
                            && worksheetDetail.ticketTemplateCode !== 'DeviceMove'
                            && worksheetDetail.ticketTemplateCode !== 'DeviceMoveV2'
                            && worksheetDetail.ticketTemplateCode !== 'DeviceMoveOut'
                            && worksheetDetail.ticketTemplateCode !== 'DeviceMoveOutV2'">
                <p>{{worksheetDetail.userContractNumber !== ""? worksheetDetail.userContractNumber:
                  "--"}}</p>
              </el-form-item>
              <!--迁入日期-->
              <el-form-item :label="$t('equipmentMoveIn.text.moveInDate') + ':'"
                            v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveIn' || worksheetDetail.ticketTemplateCode != 'DeviceMoveInV2'">
                <p>{{worksheetDetail.moveinDate !== ""? worksheetDetail.moveinDate: "--"}}</p>
              </el-form-item>
              <!--上架方式-->
              <el-form-item :label="$t('equipmentMoveIn.text.onShelfType') + ':'"
                            v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveIn' || worksheetDetail.ticketTemplateCode != 'DeviceMoveInV2'">
                <p>{{worksheetDetail.moveinType !== ""? worksheetDetail.moveinType: "--"}}</p>
              </el-form-item>
              <!--人员入室-->
              <el-form-item :label="$t('equipmentMoveIn.text.personnelBurglary') + ':'"
                            v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveIn' || worksheetDetail.ticketTemplateCode != 'DeviceMoveInV2'">
                <p>{{worksheetDetail.personIn !== ""? worksheetDetail.personIn: "--"}}</p>
              </el-form-item>
              <!--迁出日期-->
              <el-form-item :label="$t('equipmentMoveOut.text.moveOutDate') | withColon"
                            v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveOut' || worksheetDetail.ticketTemplateCode == 'DeviceMoveOutV2'">
                <p>{{worksheetDetail.moveinDate !== ""? worksheetDetail.moveoutDate: "--"}}</p>
              </el-form-item>
              <!--下架方式-->
              <el-form-item :label="$t('equipmentMoveOut.text.offShelfType') | withColon"
                            v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveOut' || worksheetDetail.ticketTemplateCode == 'DeviceMoveOutV2'">
                <p>{{worksheetDetail.moveoutType !== ""? worksheetDetail.moveoutType: "--"}}</p>
              </el-form-item>
              <!--设备关机-->
              <el-form-item :label="$t('equipmentMoveOut.text.turnOff') | withColon"
                            v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveOut' || worksheetDetail.ticketTemplateCode == 'DeviceMoveOutV2'">
                <p>{{worksheetDetail.shutDown !== ""? worksheetDetail.shutDown: "--"}}</p>
              </el-form-item>
              <!--提货方式-->
              <el-form-item :label="$t('equipmentMoveOut.text.deliveryType') | withColon"
                            v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveOut' || worksheetDetail.ticketTemplateCode == 'DeviceMoveOutV2'">
                <p>{{worksheetDetail.pickupType !== ""? worksheetDetail.pickupType: "--"}}</p>
              </el-form-item>
              <!--提货人-->
              <el-form-item :label="$t('equipmentMoveOut.text.deliveryPersonName') | withColon"
                            v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveOut' || worksheetDetail.ticketTemplateCode == 'DeviceMoveOutV2'">
                <p>{{worksheetDetail.pickupName !== ""? worksheetDetail.pickupName: "--"}}</p>
              </el-form-item>
              <!--提货人证件类型-->
              <el-form-item :label="$t('equipmentMoveOut.text.deliveryCertificate') | withColon"
                            v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveOut' || worksheetDetail.ticketTemplateCode == 'DeviceMoveOutV2'">
                <p>{{worksheetDetail.credentialsType !== ""? worksheetDetail.credentialsType:
                  "--"}}</p>
              </el-form-item>
              <!--提货人证件号码-->
              <el-form-item :label="$t('equipmentMoveOut.text.deliveryNo') | withColon"
                            v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveOut' || worksheetDetail.ticketTemplateCode == 'DeviceMoveOutV2'">
                <p>{{worksheetDetail.credentialsNo !== ""? worksheetDetail.credentialsNo: "--"}}</p>
              </el-form-item>
              <!--提货人电话-->
              <el-form-item :label="$t('equipmentMoveOut.text.deliveryPhoneNo') | withColon"
                            v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveOut' || worksheetDetail.ticketTemplateCode == 'DeviceMoveOutV2'">
                <p>{{worksheetDetail.pickupPhone !== ""? worksheetDetail.pickupPhone: "--"}}</p>
              </el-form-item>
              <!--人员入室-->
              <el-form-item :label="$t('equipmentMoveIn.text.personnelBurglary') | withColon"
                            v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveOut' || worksheetDetail.ticketTemplateCode == 'DeviceMoveOutV2'">
                <p>{{worksheetDetail.personIn !== ""? worksheetDetail.personIn: "--"}}</p>
              </el-form-item>
              <!--异动日期-->
              <el-form-item :label="$t('equipmentMove.text.moveDate') + ':'"
                            v-if="['DeviceMove', 'DeviceMoveV2'].includes(worksheetDetail.ticketTemplateCode)">
                <p>{{worksheetDetail.moveDate !== ""? worksheetDetail.moveDate: "--"}}</p>
              </el-form-item>
              <!--异动方式-->
              <el-form-item :label="$t('equipmentMove.text.moveType') + ':'"
                            v-if="['DeviceMove', 'DeviceMoveV2'].includes(worksheetDetail.ticketTemplateCode)">
                <p>{{worksheetDetail.moveType !== ""? worksheetDetail.moveType: "--"}}</p>
              </el-form-item>
              <!--设备关机-->
              <el-form-item :label="$t('equipmentMoveOut.text.turnOff') + ':'"
                            v-if="['DeviceMove', 'DeviceMoveV2'].includes(worksheetDetail.ticketTemplateCode)">
                <p>{{worksheetDetail.shutDown !== ""? worksheetDetail.shutDown: "--"}}</p>
              </el-form-item>
              <!--备注-->
              <el-form-item :label="$t('ticket.remark') + ':'">
                <p>{{worksheetDetail.remark !== ""? worksheetDetail.remark: "--"}}</p>
              </el-form-item>
              <!--附件-->
              <el-form-item :label="$t('text.enclosure') + ':'">
                <a v-if="worksheetDetail.submitAttach && (worksheetDetail.submitAttach.name !== '')"
                   href="javascript:void(0)"
                   class="text-decoration-none"
                   @click="download(worksheetDetail.submitAttach.url)">{{worksheetDetail.submitAttach.name}}</a>
                <span v-else>--</span>
              </el-form-item>
            </el-form>

            <div class="table-title"
                 v-if="worksheetDetail.ticketTemplateCode === 'DeviceMoveIn'
                    || worksheetDetail.ticketTemplateCode === 'DeviceMoveInV2'
                    || worksheetDetail.ticketTemplateCode === 'DeviceMoveOut'
                    || worksheetDetail.ticketTemplateCode === 'DeviceMoveOutV2'
                    || worksheetDetail.ticketTemplateCode === 'DeviceMove'
                    || worksheetDetail.ticketTemplateCode === 'DeviceMoveV2'
                    || worksheetDetail.ticketTemplateCode === 'VisitApplication'">
              {{ worksheetDetail.ticketTemplateCode === 'VisitApplication'
              ? $t('roomEntry.roomEntryList')
              : $t('equipmentMoveIn.text.deviceList') }}
              <img :src="encryptionFlag ? '../../../static/img/showEye.svg' : '../../../static/img/hiddenEye.svg'"
                    v-if="worksheetDetail.ticketTemplateCode === 'VisitApplication'"
                    alt="eyes" style="cursor:pointer" @click="setEncryption">
            </div>

            <div class="table-title"
                 v-if="worksheetDetail.ticketTemplateCode === 'DeviceMoveIn'
                    || worksheetDetail.ticketTemplateCode === 'DeviceMoveInV2'
                    || worksheetDetail.ticketTemplateCode === 'DeviceMoveOut'
                    || worksheetDetail.ticketTemplateCode === 'DeviceMoveOutV2'
                    || worksheetDetail.ticketTemplateCode === 'DeviceMove'
                    || worksheetDetail.ticketTemplateCode === 'DeviceMoveV2'
                    || worksheetDetail.ticketTemplateCode === 'VisitApplicationV2'">
              {{ worksheetDetail.ticketTemplateCode === 'VisitApplicationV2'
              ? $t('roomEntry.roomEntryList')
              : $t('equipmentMoveIn.text.deviceList') }}
              <img :src="encryptionFlag ? '../../../static/img/showEye.svg' : '../../../static/img/hiddenEye.svg'"
                    v-if="worksheetDetail.ticketTemplateCode === 'VisitApplicationV2'"
                    alt="eyes" style="cursor:pointer" @click="setEncryption">
            </div>
            <el-table
                      :data="worksheetDetail.deviceInfo"
                      max-height="300"
                      v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveIn' || worksheetDetail.ticketTemplateCode == 'DeviceMoveInV2'">
              <el-table-column width="50"
                               :label="this.$t('alarmHistory.index')">
                <template slot-scope="scope">
                  <span>{{scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="snNo"
                               :label="$t('equipment.snNumber')"></el-table-column>
              <el-table-column prop="deviceType"
                               :label="$t('equipment.equipmentType')"></el-table-column>
              <el-table-column prop="uNum"
                               :label="$t('equipment.uNo')"></el-table-column>
              <el-table-column prop="brand"
                               :label="$t('text.brand')"></el-table-column>
              <el-table-column prop="model"
                               :label="$t('text.model')"></el-table-column>
              <el-table-column prop="assetBelong"
                               :label="$t('equipment.assetBelonging')"></el-table-column>
              <el-table-column prop="cabinetNo"
                               :label="$t('cabinet.cabinetNumCode')">
                <template slot-scope="scope">
                  <span >{{scope.row.cabinetNo| maybeEmpty}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="rackUIndex"
                               :label="$t('text.belongUbit')">
                <template slot-scope="scope">
                  <span >{{scope.row.rackUIndex| maybeEmpty}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="remark"
              show-overflow-tooltip
                              :label="$t('text.note')">
                <template slot-scope="scope">
                  <span >{{scope.row.remark| maybeEmpty}}</span>
                </template>
              </el-table-column>
            </el-table>

            <!-- 设备数据表格 -->
            <el-table :data="worksheetDetail.deviceInfo"
                      max-height="300"
                      v-if="worksheetDetail.ticketTemplateCode == 'DeviceMoveOut' || worksheetDetail.ticketTemplateCode == 'DeviceMoveOutV2'">
              <el-table-column width="50"
                               :label="this.$t('alarmHistory.index')">
                <template slot-scope="scope">
                  <span>{{scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <!-- 设备编码 -->
              <el-table-column prop="deviceNo"
                               :label="$t('equipment.equipmentNumber')"
                               min-width="120">
                <template slot-scope="scope">
                  <span>{{scope.row.deviceNo}}</span>
                </template>
              </el-table-column>
              <!-- SN号 -->
              <el-table-column prop="snNo"
                               :label="$t('equipment.snNumber')"
                               min-width="120">
                <template slot-scope="scope">
                  <span>{{scope.row.snNo}}</span>
                </template>
              </el-table-column>
              <!-- 机柜编码 -->
              <el-table-column prop="cabinetNo"
                               :label="$t('cabinet.cabinetNumCode')"
                               min-width="140">
                <template slot-scope="scope">
                  <span>{{scope.row.cabinetNo}}</span>
                </template>
              </el-table-column>
              <!-- 所在U位 -->
              <el-table-column prop="rackUIndex"
                               :label="$t('text.belongUbit')">
                <template slot-scope="scope">
                  <span>{{scope.row.rackUIndex}}</span>
                </template>
              </el-table-column>
              <!-- U数（U）-->
              <el-table-column prop="uNum"
                               :label="$t('equipment.uNo')"
                               min-width="80">
                <template slot-scope="scope">
                  <span>{{scope.row.uNum}}</span>
                </template>
              </el-table-column>
              <!-- 设备类型 -->
              <el-table-column prop="deviceType"
                               :label="$t('equipment.equipmentType')"
                               min-width="80">
                <template slot-scope="scope">
                  <span>{{scope.row.deviceType}}</span>
                </template>
              </el-table-column>
              <!-- 品牌 -->
              <el-table-column prop="brand"
                               :label="$t('text.brand')"
                               min-width="80">
                <template slot-scope="scope">
                  <span>{{scope.row.brand}}</span>
                </template>
              </el-table-column>
              <!-- 型号 -->
              <el-table-column prop="model"
                               :label="$t('text.model')"
                               min-width="100">
                <template slot-scope="scope">
                  <span>{{scope.row.model}}</span>
                </template>
              </el-table-column>
              <!-- 资产所属 -->
              <el-table-column prop="assetBelong"
                               :label="$t('equipment.assetBelonging')">
                <template slot-scope="scope">
                  <span>{{scope.row.assetBelong}}</span>
                </template>
              </el-table-column>
            </el-table>

            <!-- 设备数据表格 -->
            <el-table :data="worksheetDetail.deviceInfo"
                      max-height="300"
                      v-if="['DeviceMove', 'DeviceMoveV2'].includes(worksheetDetail.ticketTemplateCode)">
              <el-table-column width="50"
                               :label="this.$t('alarmHistory.index')">
                <template slot-scope="scope">
                  <span>{{scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <!-- 设备编码 -->
              <el-table-column prop="deviceNo"
                               :label="$t('equipment.equipmentNumber')"
                               width="250">
                <template slot-scope="scope">
                  <span>{{scope.row.deviceNo}}</span>
                </template>
              </el-table-column>
              <!-- SN号 -->
              <el-table-column prop="snNo"
                               :label="$t('equipment.snNumber')">
                <template slot-scope="scope">
                  <span>{{scope.row.snNo}}</span>
                </template>
              </el-table-column>
              <!-- U数（U）-->
              <el-table-column prop="uNum"
                               :label="$t('equipment.uNo')">
                <template slot-scope="scope">
                  <span>{{scope.row.uNum}}</span>
                </template>
              </el-table-column>
              <!-- 设备类型 -->
              <el-table-column prop="deviceType"
                               :label="$t('equipment.equipmentType')">
                <template slot-scope="scope">
                  <span>{{scope.row.deviceType}}</span>
                </template>
              </el-table-column>
              <!-- 品牌 -->
              <el-table-column prop="brand"
                               :label="$t('text.brand')">
                <template slot-scope="scope">
                  <span>{{scope.row.brand}}</span>
                </template>
              </el-table-column>
              <!-- 型号 -->
              <el-table-column prop="model"
                               :label="$t('text.model')">
                <template slot-scope="scope">
                  <span>{{scope.row.model}}</span>
                </template>
              </el-table-column>
              <!-- 资产所属 -->
              <el-table-column prop="assetBelongName"
                               :label="$t('equipment.assetBelonging')">
                <template slot-scope="scope">
                  <span>{{scope.row.assetBelong}}</span>
                </template>
              </el-table-column>
              <!-- 当前机柜 -->
              <el-table-column prop="cabinetNo"
                               :label="$t('equipmentMove.text.currentCabinet')">
                <template slot-scope="scope">
                  <span>{{scope.row.cabinetNo}}</span>
                </template>
              </el-table-column>
              <!-- 当前U位 -->
              <el-table-column prop="rackUIndex"
                               :label="$t('equipmentMove.text.currentUBit')">
                <template slot-scope="scope">
                  <span>{{scope.row.rackUIndex}}</span>
                </template>
              </el-table-column>
              <!-- 迁入机柜 -->
              <el-table-column prop="movetoCabinetNo"
                               :label="$t('equipmentMove.text.targetCabinet')">
                <template slot-scope="scope">
                  <span>{{scope.row.movetoCabinetNo}}</span>
                </template>
              </el-table-column>
              <!-- 迁入U位 -->
              <el-table-column prop="movetoUIndex"
                               :label="$t('equipmentMove.text.targetUBit')">
                <template slot-scope="scope">
                  <span>{{scope.row.movetoUIndex}}</span>
                </template>
              </el-table-column>
            </el-table>
            <!--人员入室表格-->
            <el-table :data="roomEntryLists"
                      max-height="500"
                      v-if="worksheetDetail.ticketTemplateCode === 'VisitApplication'">
              <!-- 序号 -->
              <el-table-column width="50"
                               prop="serialNo"
                               type="index"
                               :label="this.$t('alarmHistory.index')">
              </el-table-column>
              <!-- 姓名 -->
              <el-table-column prop="name"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.name')"
                               min-width="80">
                <template slot-scope="scope">
                      <span v-if="encryptionFlag">{{scope.row.name | maybeEmpty }}</span>
                      <span v-else>{{scope.row.namePass | maybeEmpty }}</span>
                    </template>
              </el-table-column>
              <!-- 证件类型 -->
              <el-table-column prop="certificates"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.paperworkType')"
                               min-width="80">
                <template slot-scope="scope">
                  <span>{{scope.row.certificates}}</span>
                </template>
              </el-table-column>
              <!-- 证件号码-->
              <el-table-column prop="number"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.paperworkNumber')"
                               min-width="150">
                <template slot-scope="scope">
                      <span v-if="encryptionFlag">{{scope.row.number | maybeEmpty }}</span>
                      <span v-else>{{scope.row.numberPass | maybeEmpty }}</span>
                    </template>
              </el-table-column>
              <!-- 电话 -->
              <el-table-column prop="phone"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.mobile')"
                               min-width="120">
                <template slot-scope="scope">
                      <span v-if="encryptionFlag">{{scope.row.phone | maybeEmpty }}</span>
                      <span v-else>{{scope.row.phonePass | maybeEmpty }}</span>
                    </template>
              </el-table-column>
              <!--公司名称-->
              <el-table-column prop="company"
                               :label="$t('roomEntry.tableTitle.company')"
                               show-overflow-tooltip
                               min-width="100">
                <template slot-scope="scope">
                  <span>{{scope.row.company}}</span>
                </template>
              </el-table-column>
              <!-- 进入日期 -->
              <el-table-column prop="startTime"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.startTime')"
                               min-width="80">
                <template slot-scope="scope">
                  <span>{{scope.row.startTime}}</span>
                </template>
              </el-table-column>
              <!-- 结束日期 -->
              <el-table-column prop="endTime"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.endTime')"
                               min-width="100">
                <template slot-scope="scope">
                  <span>{{scope.row.endTime}}</span>
                </template>
              </el-table-column>
              <!-- 进入原因 -->
              <el-table-column prop="reason"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.entryReason')">
                <template slot-scope="scope">
                  <span>{{scope.row.reason}}</span>
                </template>
              </el-table-column>
              <!-- 携带物品 -->
              <el-table-column prop="belongings"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.brings')">
                <template slot-scope="scope">
                  <span>{{scope.row.belongings | maybeEmpty}}</span>
                </template>
              </el-table-column>
              <!-- 车辆信息 -->
              <el-table-column prop="vehicle"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.carInfo')">
                <template slot-scope="scope">
                  <span>{{scope.row.vehicle | maybeEmpty}}</span>
                </template>
              </el-table-column>
              <!-- 备注 -->
              <el-table-column prop="remark"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.remark')">
                <template slot-scope="scope">
                  <span>{{scope.row.remark | maybeEmpty}}</span>
                </template>
              </el-table-column>
            </el-table>
            <!-- 人员入室-无进入原因 -->
            <el-table :data="roomEntryLists"
                      max-height="500"
                      v-if="worksheetDetail.ticketTemplateCode === 'VisitApplicationV2'">
              <!-- 序号 -->
              <el-table-column width="50"
                               prop="serialNo"
                               type="index"
                               :label="this.$t('alarmHistory.index')">
              </el-table-column>
              <!-- 姓名 -->
              <el-table-column prop="name"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.name')"
                               min-width="80">
                <template slot-scope="scope">
                      <span v-if="encryptionFlag">{{scope.row.name | maybeEmpty }}</span>
                      <span v-else>{{scope.row.namePass | maybeEmpty }}</span>
                    </template>
              </el-table-column>
              <!-- 证件类型 -->
              <el-table-column prop="certificates"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.paperworkType')"
                               min-width="80">
                <template slot-scope="scope">
                  <span>{{scope.row.certificates}}</span>
                </template>
              </el-table-column>
              <!-- 证件号码-->
              <el-table-column prop="number"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.paperworkNumber')"
                               min-width="150">
                <template slot-scope="scope">
                      <span v-if="encryptionFlag">{{scope.row.number | maybeEmpty }}</span>
                      <span v-else>{{scope.row.numberPass | maybeEmpty }}</span>
                    </template>
              </el-table-column>
              <!-- 电话 -->
              <el-table-column prop="phone"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.mobile')"
                               min-width="120">
                <template slot-scope="scope">
                      <span v-if="encryptionFlag">{{scope.row.phone | maybeEmpty }}</span>
                      <span v-else>{{scope.row.phonePass | maybeEmpty }}</span>
                    </template>
              </el-table-column>
              <!--公司名称-->
              <el-table-column prop="company"
                               :label="$t('roomEntry.tableTitle.company')"
                               show-overflow-tooltip
                               min-width="100">
                <template slot-scope="scope">
                  <span>{{scope.row.company}}</span>
                </template>
              </el-table-column>
              <!-- 进入日期 -->
              <el-table-column prop="startTime"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.startTime')"
                               min-width="80">
                <template slot-scope="scope">
                  <span>{{scope.row.startTime}}</span>
                </template>
              </el-table-column>
              <!-- 结束日期 -->
              <el-table-column prop="endTime"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.endTime')"
                               min-width="100">
                <template slot-scope="scope">
                  <span>{{scope.row.endTime}}</span>
                </template>
              </el-table-column>
              <!-- 进入原因 -->
              <!-- <el-table-column prop="reason"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.entryReason')">
                <template slot-scope="scope">
                  <span>{{scope.row.reason}}</span>
                </template>
              </el-table-column> -->
              <!-- 携带物品 -->
              <el-table-column prop="belongings"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.brings')">
                <template slot-scope="scope">
                  <span>{{scope.row.belongings | maybeEmpty}}</span>
                </template>
              </el-table-column>
              <!-- 车辆信息 -->
              <el-table-column prop="vehicle"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.carInfo')">
                <template slot-scope="scope">
                  <span>{{scope.row.vehicle | maybeEmpty}}</span>
                </template>
              </el-table-column>
              <!-- 备注 -->
              <el-table-column prop="remark"
                               show-overflow-tooltip
                               :label="$t('roomEntry.tableTitle.remark')">
                <template slot-scope="scope">
                  <span>{{scope.row.remark | maybeEmpty}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="el-section"
             v-if="serviceSupportCode.indexOf(ticketTemplateCode) === -1 && ticketTemplateCode !== 'DeviceMoveIn' && ticketTemplateCode !== 'DeviceMoveInV2' && ticketTemplateCode !== 'DeviceMove' && ticketTemplateCode !== 'DeviceMoveV2'">
          <div class="el-section-header">
            <h3 class="el-section-title">{{$t('text.enclosure')}}</h3>
          </div>
          <div class="el-section-content">
            <div class="enclosure-box">
              <div v-if="worksheetDetail['attach']['consumer']">
                <p class="enclosure-type-title">{{$t('ticket.customerUpload')}}：</p>
                <div class="enclosure-item"
                     v-for="(item,index) in worksheetDetail.attach.consumer"
                     :key="index">
                  <p class="enclosure-item-title">
                    <a :href="item.url"
                       target="_self"
                       :title="$t('ticket.clickDownload')">{{item.name}}</a>
                  </p>
                  <p class="enclosure-item-remark">{{item.tips}}</p>
                </div>
              </div>
              <div v-if="worksheetDetail.attach.system">
                <p class="enclosure-type-title system">{{$t('ticket.systemUpload')}}：</p>
                <div class="enclosure-item"
                     v-for="(item,index) in worksheetDetail.attach.system"
                     :key="index">
                  <p class="enclosure-item-title">
                    <a :href="item.url"
                       target="_self"
                       :title="$t('ticket.clickDownload')">{{item.name}}</a>
                  </p>
                  <p class="enclosure-item-remark">{{item.tips}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 处理结果 -->
        <ticket-info :ticketTitle="$t('serviceSupport.processResult')"
                     :finishInfo="finishInfo"
                     v-if="serviceSupportCode.indexOf(ticketTemplateCode) > -1 || ticketTemplateCode === 'DeviceMoveIn'|| ticketTemplateCode === 'DeviceMove'|| ticketTemplateCode === 'DeviceMoveV2'"></ticket-info>
      </div>
    </div>
    <!-- 弹框 -->
    <dailog-show :currentDailog.sync="currentDailog"
                 :currentTicketNo.sync="currentTicketNo"
                 @updateList="updateList('refresh')"
                 :currentTaskNodeId.sync="currentTaskNodeId"></dailog-show>

  </div>
</template>

<script>
import dailogShow from './WorksheetAction';
import TicketSteps from './common/TicketSteps';
import ticketInfo from './common/TicketInfo';
import ticketInfoTable from './common/TicketInfoTable';
import GeneralServicesTable from './common/GeneralServicesTable';
import ResourceTable from './common/ResourceTable';


import packageInfo from './common/PackageInfo';

import accessoryTable from './common/AccessoryTable';
import cabinetTable from './common/CabinetTable';
import cabinetAB from './common/CabinetABTable';

import cabinetPower from './cabinet-powerUp/opt/ShowCabinetsDetail';
import cabinetReserve from './cabinet-reservation/opt/ShowCabinetsDetail';
import deviceUndescrib from './equipment-unsubscribe/opt/ShowEquipmentsDetail';

export default {
  components: {
    dailogShow,
    TicketSteps,
    ticketInfo,
    ticketInfoTable,
    accessoryTable,
    cabinetTable,
    cabinetAB,
    packageInfo,
    cabinetPower,
    cabinetReserve,
    GeneralServicesTable,
    deviceUndescrib,
    ResourceTable
  },
  data () {
    return {
      objReason: false,
      encryptionFlag: false,
      ticketNo: null,
      serviceSupportCode: [
        // 服务支持11类
        'DeviceView', 'NetworkMaint', 'PeripheralAccess', 'IPConfig', 'OtherService', 'RemoteConnection', 'DeviceShutDown', 'DeviceBoot', 'ResetBMC', 'SystemReinstall', 'DeviceReboot',
        // 服务支持新增5类
        'DeviceNetoff', 'DevicePoweroff', 'CabinetView', 'ReplacementChange', 'VerifyWiringDistance',
        // 故障提报4类
        'HardDiskFault', 'PowerFault', 'CableFault', 'OtherFault',
        // 收发快递模块
        'CollectDelivery', 'SendDelivery',
        // 机柜开通
        'CabinetElectrified',
        // 机柜预留
        'CabinetReservation',
        // 通用工单
        'GeneralServices',
        // 机柜关电
        'CabinetPowerOff',
        // 设备退订
        'DeviceUnsubscribe',
        // 设备开通
        'DeviceOpen'
      ],
      // 步骤条数据原始
      ticketSteps: [],
      // 基本信息
      baseInfo: [],
      // 申请信息
      applyInfo: [],
      // 设备列表
      deviceInfoList: [],
      // 包裹清单
      packageInfo: [],
      // 附件信息
      attachInfo: [],
      // 处理结果
      finishInfo: {},
      // 配置信息
      accessoryInfoList: [],
      // 机柜信息
      cabinetInfoList: [],
      ticketTemplateCode: null,
      userOperation: [], // 工单操作
      worksheetDetail: {
        attach: {
          consumer: [],
          system: []
        }
      }, // 工单详情信息
      currentTicketNo: null, // 当前操作工单号
      currentDailog: '', // 操作弹窗
      currentTaskNodeId: '', // 当前节点,
      deviceMoveArray: ['DeviceMoveIn', 'DeviceMoveInV2', 'DeviceMoveOut', 'DeviceMove', 'DeviceMoveV2', 'CabinetOutfit'],
      roomEntryTemplateCode: ['VisitApplication', 'VisitApplicationV2'],
      // 人员入室表格绑定值
      roomEntryLists: [],
      ticketExtra: []
    };
  },
  created () {
    this.ticketNo = this.$route.params.id;
    this.getWorksheetDetail();
  },
  mounted () { },
  watch: {},
  computed: {},
  methods: {
    hasShowTooltip(event, row, text, num = 2.3) {
        // event为鼠标移入时的事件对象
        // textWidth 为文本在页面中所占的宽度，创建标签，加入到页面，获取textWidth ,最后在移除
        const createSpan = document.createElement('span');
        // 文本内容
        createSpan.innerText = text;
        // 文本class类
        createSpan.className = 'getTextWidth'
        // body里添加
        document.querySelector('body').appendChild(createSpan);
        // 类型断言，获取文本offsetWidth
        const textWidth = document.querySelector('.getTextWidth').offsetWidth;
        // 移除
        document.querySelector('.getTextWidth').remove();
        // tableWidth为表格容器的宽度、类型断言
        const tableWidth = event.target.offsetWidth;
        // 当文本宽度小于等于容器宽度两倍时，这块会有点小误差，根据业务来换算，代表文本显示未超过两行
        textWidth <= Math.ceil(num * tableWidth) ? row.showTooltip = false : row.showTooltip = true;
    },
    setEncryption() {
      this.encryptionFlag = !this.encryptionFlag;
    },
    getWorksheetDetail () {
      const params = {
        ticketNo: this.ticketNo
      };
      this.$api.getWorksheetDetail(params).then((temp) => {
        if (temp.errno === 10000 && temp.errmsg === 'OK') {
          if (temp.data) {
            this.userOperation = [];
            // 工单Code
            this.ticketTemplateCode = temp.data.ticketTemplateCode;
            // 步骤信息
            this.ticketSteps = [].concat(temp.data.userFlowChart);
            // 设备信息
            this.deviceInfoList = [].concat(temp.data.deviceInfo);
            // 包裹清单
            this.packageInfo = [].concat(temp.data.packageInfo);
            // 设备外置配件工单 配置信息
            if (this.ticketTemplateCode === 'ReplacementChange') {
              this.accessoryInfoList = [].concat(temp.data.accessoryInfo);
            }
            // 查看机柜工单&核验布线距离 机柜信息(如果不需要设备信息 需要再次加入工单code)
            if (['CabinetView', 'VerifyWiringDistance', 'CabinetElectrified', 'CabinetReservation', 'CabinetPowerOff'].indexOf(this.ticketTemplateCode) > -1) {
              this.deviceInfoList = [];
              this.cabinetInfoList = [].concat(temp.data.cabinetInfo);
            }
            // 附件信息
            this.attachInfo = Object.assign({}, temp.data.submitAttach);
            // 处理结果
            this.finishInfo = Object.assign({}, temp.data.finishInfo);
            temp.data.userOperation.forEach((element) => {
              this.userOperation.push(element);
            });
            this.worksheetDetail = Object.assign({}, temp.data);
            // 基本信息
            this.baseInfo = [{
              label: this.$t('ticket.ticketNo'),
              value: this.worksheetDetail.ticketNo
            },
            {
              label: this.$t('ticket.workName'),
              value: this.worksheetDetail.ticketName
            },
            {
              label: this.$t('ticket.workType'),
              value: this.worksheetDetail.ticketTypeName
            },
            {
              label: this.$t('ticket.workStatus'),
              value: this.worksheetDetail.ticketStatus
            },
            {
              label: this.$t('ticket.setUpTime'),
              value: this.worksheetDetail.createdTime
            },
            {
              label: this.$t('ticket.closeTime'),
              value: this.worksheetDetail.closedTime
            }];
            // 申请信息
            this.applyInfo = [
              //   {
              //   label: this.$t('ticket.userPin'),
              //   value: this.worksheetDetail.pin
              // },
              {
                label: this.$t('text.applyId'),
                value: this.worksheetDetail.applyId
              },
              {
                label: this.$t('text.tel'),
                value: this.worksheetDetail.userTel
              },
              {
                label: this.$t('text.email'),
                value: this.worksheetDetail.userEmail
              },
              {
                label: this.$t('merge.roomName'),
                value: this.worksheetDetail.region
              },
              {
                label: this.$t('serviceSupport.personnelBurglary'),
                value: this.worksheetDetail.personIn
              },
              {
                label: this.$t('ticket.remark'),
                value: this.worksheetDetail.remark,
                line: true
              }];
            // 系统重装
            if (this.ticketTemplateCode === 'SystemReinstall') {
              if (this.worksheetDetail.mirrorType === '8') {
                this.applyInfo.splice(5, 0, {
                  label: this.$t('serviceSupport.systemImage'),
                  value: `${this.$t('serviceSupport.other')} (${this.worksheetDetail.mirrorName})`
                });
              } else {
                this.applyInfo.splice(5, 0, {
                  label: this.$t('serviceSupport.systemImage'),
                  value: this.worksheetDetail.mirrorName
                });
              }
            }
            const FaultArr = ['PeripheralAccess', 'ReplacementChange', 'HardDiskFault', 'PowerFault', 'CableFault', 'OtherFault'];
            // 故障提报 外置配件更换&外设接入
            if (FaultArr.indexOf(this.ticketTemplateCode) > -1) {
              this.applyInfo.splice(4, 0, {
                label: this.$t('serviceSupport.collectionAccessories'),
                value: this.worksheetDetail.courierTypeName
              });
              this.applyInfo.splice(5, 0, {
                label: this.$t('serviceSupport.expressCompany'),
                value: this.worksheetDetail.courierCompany
              });
              this.applyInfo.splice(6, 0, {
                label: this.$t('serviceSupport.trackingNumbe'),
                value: this.worksheetDetail.courierCode
              });
            }
            if (['HardDiskFault', 'PowerFault', 'CableFault', 'OtherFault'].indexOf(this.ticketTemplateCode) > -1) {
              // 故障四类根据机房添加外部机房联系人电话，联系人，联系人地址，
              console.log(878, this.worksheetDetail.externalIdcAddr);
              if (this.worksheetDetail.isExternalIdc) {
                this.applyInfo.splice(4, 0, {
                  label: this.$t('equipmentUnsubscribe.outsideMobile'),
                  value: this.worksheetDetail.externalIdcContactPhone
                });
                this.applyInfo.splice(4, 0, {
                  label: this.$t('equipmentUnsubscribe.outsideContact'),
                  value: this.worksheetDetail.externalIdcContactPerson
                });
                this.applyInfo.splice(4, 0, {
                  label: this.$t('equipmentUnsubscribe.outsideIDC'),
                  value: this.worksheetDetail.externalIdcAddress
                });
              }
            }
            // 设备外置配件更换
            if (this.ticketTemplateCode === 'ReplacementChange') {
              this.applyInfo.splice(7, 0, {
                label: this.$t('serviceSupport.shutDown'),
                value: this.worksheetDetail.authShutdown
              });
            }
            // 机柜加电
            if (this.ticketTemplateCode === 'CabinetElectrified') {
              this.applyInfo.splice(4, 1);
              this.applyInfo.splice(4, 0, {
                label: this.$t('cabinetPowerUp.powerUpTime'),
                value: this.worksheetDetail.targetOpenTime
              });
              this.applyInfo.splice(5, 0, {
                label: this.$t('ticket.contractEditNum'),
                value: this.worksheetDetail.userContractNumber
              });
            }
            // 【机柜预留】 【申请信息】 差异部分
            if (this.ticketTemplateCode === 'CabinetReservation') {
              // 修改申请信息
              this.applyInfo.splice(4, 1);
              this.applyInfo.splice(4, 0, {
                label: this.$t('cabinetReservation.applyTime'),
                value: this.worksheetDetail.reserveTime
              });
              this.applyInfo.splice(5, 0, {
                label: this.$t('cabinetReservation.reserveReq'),
                value: this.worksheetDetail.reserveType
              });
            }
            // 机柜关电
            if (this.ticketTemplateCode === 'CabinetPowerOff') {
              this.applyInfo.splice(4, 1);
              this.applyInfo.splice(3, 0, {
                label: this.$t('cabinetPowerOff.powerOffNeed'),
                value: this.worksheetDetail.powerOffTypeName
              });
              this.applyInfo.splice(5, 0, {
                label: this.$t('cabinetPowerOff.powerOffTime'),
                value: this.worksheetDetail.targetPowerOffTime
              });
              this.ticketExtra.push({
                label: this.$t('cabinetPowerOff.powerOffTip'),
                value: this.worksheetDetail.powerOffConfirmed
              });
            }
            // 代收快递
            if (this.ticketTemplateCode === 'CollectDelivery') {
              this.applyInfo.splice(4, 1, {
                label: this.$t('serviceSupport.expressCompany'),
                value: this.worksheetDetail.courierCompany
              });
              this.applyInfo.splice(5, 0, {
                label: this.$t('serviceSupport.trackingNumbe'),
                value: this.worksheetDetail.courierCode
              });
              this.applyInfo.splice(6, 0, {
                label: this.$t('expressDelivery.estimatedArrivalDate'),
                value: `${this.worksheetDetail.estimatedArrivalDate.startDate}~${this.worksheetDetail.estimatedArrivalDate.endDate}`
              });
              this.applyInfo.splice(7, 0, {
                label: this.$t('expressDelivery.shippingAddress'),
                value: this.worksheetDetail.shippingAddress
              });
              this.applyInfo.splice(8, 0, {
                label: this.$t('expressDelivery.recipientContacts'),
                value: this.worksheetDetail.recipient
              });
              this.applyInfo.splice(9, 0, {
                label: this.$t('expressDelivery.recipientContacts') + this.$t('text.tel'),
                value: this.worksheetDetail.recipientMobile
              });
            }
            // 代发快递
            if (this.ticketTemplateCode === 'SendDelivery') {
              this.applyInfo.splice(4, 1, {
                label: this.$t('serviceSupport.expressCompany'),
                value: this.worksheetDetail.courierCompany
              });
              this.applyInfo.splice(5, 0, {
                label: this.$t('expressDelivery.estimatedPickupDate'),
                value: this.worksheetDetail.estimatedPickupDate
              });
              this.applyInfo.splice(6, 0, {
                label: this.$t('expressDelivery.shippingAddress'),
                value: this.worksheetDetail.shippingAddress
              });
              this.applyInfo.splice(7, 0, {
                label: this.$t('expressDelivery.recipientContacts'),
                value: this.worksheetDetail.recipient
              });
              this.applyInfo.splice(8, 0, {
                label: this.$t('expressDelivery.recipient') + this.$t('expressDelivery.recipientMobile'),
                value: this.worksheetDetail.recipientMobile
              });
              this.applyInfo.splice(9, 0, {
                label: this.$t('expressDelivery.idcAddress'),
                value: this.worksheetDetail.idcAddress
              });
              this.applyInfo.splice(10, 0, {
                label: this.$t('expressDelivery.idcManagerPhone'),
                value: this.worksheetDetail.idcManagerPhone
              });
              this.applyInfo.splice(11, 0, {
                label: this.$t('expressDelivery.sender') + this.$t('text.fullName'),
                value: this.worksheetDetail.sender
              });
              this.applyInfo.splice(12, 0, {
                label: this.$t('expressDelivery.sender') + this.$t('expressDelivery.recipientMobile'),
                value: this.worksheetDetail.senderMobile
              });
            }
            // 通用工单
            if (this.ticketTemplateCode === 'GeneralServices') {
              this.applyInfo = [{
                label: this.$t('text.applyId'),
                value: this.worksheetDetail.applyId
              }, {
                label: this.$t('text.tel'),
                value: this.worksheetDetail.userTel
              },
              {
                label: this.$t('text.email'),
                value: this.worksheetDetail.userEmail
              },
              {
                label: this.$t('merge.roomName'),
                value: this.worksheetDetail.region
              },
              {
                label: this.$t('GeneralServices.count'),
                value: this.worksheetDetail.count.toString(),
                line: true
              },
              {
                label: this.$t('ticket.remark'),
                value: this.worksheetDetail.remark,
                line: true
              }
              ];
              if (this.worksheetDetail.isExternalIdc) {
                this.applyInfo.splice(4, 0, {
                  label: this.$t('equipmentUnsubscribe.outsideMobile'),
                  value: this.worksheetDetail.externalIdcContactPhone
                });
                this.applyInfo.splice(4, 0, {
                  label: this.$t('equipmentUnsubscribe.outsideContact'),
                  value: this.worksheetDetail.externalIdcContactPerson
                });
                this.applyInfo.splice(4, 0, {
                  label: this.$t('equipmentUnsubscribe.outsideIDC'),
                  value: this.worksheetDetail.externalIdcAddress
                });
              }
            }
            // 设备退订
            if (this.ticketTemplateCode === 'DeviceUnsubscribe') {
              this.applyInfo = [{
                label: this.$t('text.applyId'),
                value: this.worksheetDetail.applyId
              }, {
                label: this.$t('text.tel'),
                value: this.worksheetDetail.userTel
              },
              {
                label: this.$t('text.email'),
                value: this.worksheetDetail.userEmail
              },
              {
                label: this.$t('merge.roomName'),
                value: this.worksheetDetail.region
              },
              {
                label: this.$t('equipmentUnsubscribe.unsubscribeTime'),
                value: this.worksheetDetail.targetUnsubscribeTime
              },
              {
                label: this.$t('ticket.remark'),
                value: this.worksheetDetail.remark,
                line: true
              }];
              if (this.worksheetDetail.idcAddress) {
                this.applyInfo.splice(4, 0, {
                  label: this.$t('equipmentUnsubscribe.outsideIDC'),
                  value: this.worksheetDetail.idcAddress
                });
              }
              this.ticketExtra = [{
                label: this.$t('equipmentUnsubscribe.dataBackup'),
                value: this.worksheetDetail.dataBackupConfirmed
              }, {
                label: this.$t('equipmentUnsubscribe.dataErasure'),
                value: this.worksheetDetail.dataErasureConfirmed
              }];
            }
            // 设备开通
            if (this.ticketTemplateCode === 'DeviceOpen') {
              this.applyInfo = [{
                label: this.$t('text.applyId'),
                value: this.worksheetDetail.applyId
              }, {
                label: this.$t('text.tel'),
                value: this.worksheetDetail.userTel
              },
              {
                label: this.$t('text.email'),
                value: this.worksheetDetail.userEmail
              },
              {
                label: this.$t('merge.roomName'),
                value: this.worksheetDetail.region
              },
              {
                label: this.$t('cabinetPowerUp.powerUpTime'),
                value: this.worksheetDetail.targetOpenTime
              },
              {
                label: this.$t('ticket.contractEditNum'),
                value: this.worksheetDetail.userContractNumber
              },
              {
                label: this.$t('ticket.remark'),
                value: this.worksheetDetail.remark,
                line: true
              }];
              console.log(1073, this.worksheetDetail.externalIdcAddr);
              if (this.worksheetDetail.externalIdcAddr) {
                this.applyInfo.splice(4, 0, {
                  label: this.$t('equipmentUnsubscribe.outsideIDC'),
                  value: this.worksheetDetail.externalIdcAddr
                });
              }
            }
            const tempCode = this.worksheetDetail.ticketTemplateCode;
            if (this.roomEntryTemplateCode.indexOf(tempCode) !== -1) {
              this.roomEntryLists = temp.data.visitorInfo;
            }
          } else {
            this.worksheetDetail = null;
          }
        } else {
          this.$message.error(temp.errmsg);
        }
      });
    },

    getCurrentNodeStatus (num) {
      switch (num) {
        case 1: {
          return 'el-icon-check';
        }
        case 2: {
          return 2;
        }
        case 3: {
          return '';
        }
        case 4: {
          return 'el-icon-minus';
        }
        case 5: {
          return 'el-icon-close';
        }
        default: { }
      }
    },

    download (url) {
      // 模板下载
      console.log(`模板下载${url}`);
      if (url != null) {
        // 获取最后一个.的位置
        var index = url.lastIndexOf('.');
        // 获取后缀
        var ext = url.substr(index + 1);
        if (this.isAssetTypeAnImage(ext)) {
          window.open(url, '_blank');
        } else {
          window.open(url, '_self');
        }
      } else {
        // 获取最后一个.的位置
        var index = this.attachUrl.lastIndexOf('.');
        // 获取后缀
        var ext = this.attachUrl.substr(index + 1);
        if (this.isAssetTypeAnImage(ext)) {
          window.open(this.attachUrl, '_blank');
        } else {
          window.open(this.attachUrl, '_self');
        }
      }
    },

    updateList (type) {
      if (type === 'refresh') {
        this.refreshloading = true;
      }
      this.getWorksheetDetail();
    },

    goBack () {
      this.$router.push({
        name: 'MyWorksheet',
      });
    },

    downloadFile (url) {
      if (url !== null && url !== '') {
        const index = url.lastIndexOf('.');
        const ext = url.substr(index + 1);
        if (this.isAssetTypeAnImage(ext)) {
          window.open(url, '_blank');
        } else {
          window.open(url, '_self');
        }
      } else return false;
    },

    isAssetTypeAnImage (text) {
      return ['png', 'jpg', 'pdf'].indexOf(text.toLowerCase()) !== -1;
    },

    handleOption (ticketNo, type) {
      this.currentTicketNo = ticketNo;
      this.currentTaskNodeId = this.worksheetDetail.currentTaskNodeId;
      if (type === 'close') {
        this.currentDailog = 'close';
      } else if (type === 'revoke') {
        this.currentDailog = 'revoke';
      } else if (type === 'verify1') {
        this.currentDailog = 'verify1';
      } else if (type === 'verify2') {
        this.currentDailog = 'verify2';
      } else if (type === 'verifyConfirm') {
        this.currentDailog = 'verifyConfirm';
      } else return false;
    }
  }
};
</script>
<style lang="scss">
.jc-datashow-list .el-form-item{
  display: inline-block;
  width: 30%;
  padding-right: 20px;
  vertical-align: top;
}
.el-section+.el-section {
    border-top: 1px dotted #d9e1e9;
    padding-top: 20px;
    margin-bottom: 20px;
  }

  .more-text-ellipsis {
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .custom-tooltip-text {
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/workSheet/WorksheetDetail.vue